import { gSupportPortal } from "../whitelabel/brand";

export function LaunchZendeskHelp(page) {
  var helpURL = gSupportPortal;
  if (page) {
    helpURL += `/hc/en-us/articles/${page}`;
  }
  window.open(helpURL);
}
